import Vue from 'vue';
import './plugins/vuetify';
import VueWait from 'vue-wait';
import Vuelidate from 'vuelidate';
import VueMoment from 'vue-moment';
import VueAxios from 'vue-axios';
import VueAuthenticate from 'vue-authenticate';
import VueNumeralFilterInstaller from 'vue-numeral-filter';
import axios from 'axios';
import TreeView from 'vue-json-tree-view';
import VueTruncate from 'vue-truncate-filter';
import VueSnackbar from './plugins/vue-snackbar';
import { createProvider } from './vue-apollo';
import router from './router';
import store from './store';
import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(VueMoment);
Vue.use(Vuelidate);
Vue.use(VueWait);
Vue.use(TreeView);
Vue.use(VueSnackbar, {
  store,
  defaultOptions: { dismissable: true, timeout: 6000 },
});
Vue.use(VueNumeralFilterInstaller);
Vue.use(VueAxios, axios);
Vue.use(VueTruncate);
Vue.use(VueAuthenticate, {
  providers: {
    vsc: {
      name: 'vsc',
      clientId: process.env.VUE_APP_VCS_CLIENT_ID,
      redirectUri: process.env.VUE_APP_VSC_REDIRECT_URI,
      authorizationEndpoint: 'https://account.vscentrum.be/django/oauth/authorize/',
      defaultUrlParams: ['response_type', 'redirect_uri', 'client_id', 'scope'],
      scope: ['read'],
      scopeDelimeter: ' ',
      oauthType: '2.0',
      responseType: 'token',
    },
  },
});

new Vue({
  router,
  store,
  wait: new VueWait({ useVuex: true }),
  apolloProvider: createProvider({
    httpEndpoint: process.env.VUE_APP_GRAPHQL_ENDPOINT,
    inMemoryCacheOptions: { freezeResults: false },
    wsEndpoint: null,
  }),
  render: (h) => h(App),
}).$mount('#app');
